import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueI18n from "vue-i18n";
import messages from "./lang";
import vuetify from "./plugins/vuetify";

library.add(fas);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VueI18n);

const dateTimeFormats = {
  es: {
    dayShort: {
      day: "2-digit"
    },
    dayText: {
      weekday: "long"
    },
    monthText: {
      month: "long"
    },
    short: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    },
    long: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  },
  en: {
    dayShort: {
      day: "2-digit"
    },
    dayText: {
      weekday: "long"
    },
    monthText: {
      month: "long"
    },
    short: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    },
    long: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  },
  fr: {
    dayShort: {
      day: "2-digit"
    },
    dayText: {
      weekday: "long"
    },
    monthText: {
      month: "long"
    },
    short: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    },
    long: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  },
  de: {
    dayShort: {
      day: "2-digit"
    },
    dayText: {
      weekday: "long"
    },
    monthText: {
      month: "long"
    },
    short: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    },
    long: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  },
  it: {
    hourShort: {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    },
    dayShort: {
      day: "numeric"
    },
    dayText: {
      weekday: "long"
    },
    monthText: {
      month: "long"
    },
    short: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    },
    long: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  },
  pt: {
    hourShort: {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    },
    dayShort: {
      day: "numeric"
    },
    dayText: {
      weekday: "long"
    },
    monthText: {
      month: "long"
    },
    short: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    },
    long: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  }
};

export const i18n = new VueI18n({
  locale: navigator.language ? navigator.language.split("-")[0] : "es",
  fallbackLocale: "es",
  messages,
  dateTimeFormats
});

Vue.prototype.$showError = function() {
  this.$root.$message(
    this.$t("global.error"),
    this.$t("global.error.genericMessage"),
    { color: "blue" }
  );
};

Vue.prototype.$showErrorCode = function(code) {
  let messageProp = `global.error.api.${code}`;
  let message = i18n.t(messageProp);
  if (messageProp === message) {
    message = this.$t("global.error.genericMessage");
  }
  this.$root.$message(this.$t("global.error"), message, { color: "blue" });
};

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
